interface BorderRadiuses {
  normal: string
  round: string
}

interface BorderStyles {
  active: string
  dashed: string
  inactive: string
  normal: string
  ribbon: string
  transparent: string
  table: string
}

interface Widths {
  minWidth: string
  maxWidth: string
}

interface ThemeColors {
  background: string
  backgroundDisabled: string
  backgroundError: string
  backgroundHover: string
  backgroundInfo: string
  backgroundLaneError: string
  backgroundLight: string
  backgroundReturnLink: string
  backgroundSecondary: string
  backgroundSuccess: string
  black: string
  borderLight: string
  borderMenu: string
  borderSecondary: string
  danger: string
  inactive: string
  light: string
  main: string
  text: string
  textConfirmation: string
  textError: string
  textInfo: string
  textNoMatch: string
  textPlaceholder: string
  textSecondary: string
  textStatusYellow: string
  textSuccess: string
  white: string
}

export const colors: ThemeColors = {
  background: '#F5F4F5',
  backgroundDisabled: '#F2F2F2',
  backgroundError: '#FFCCBC',
  backgroundHover: '#E7EBEF',
  backgroundInfo: '#C0E1F5',
  backgroundLaneError: '#ffebe4',
  backgroundLight: '#DEDEDE',
  backgroundReturnLink: '#CFD6DC',
  backgroundSecondary: '#333B43',
  backgroundSuccess: '#C5FAD2',
  black: '#000000',
  borderLight: '#B2B8BB',
  borderMenu: '#979797',
  borderSecondary: '#6A7884',
  danger: '#E86C60',
  inactive: '',
  light: '#F0F0F0',
  main: '#29D454',
  text: '#303030',
  textConfirmation: '#505050',
  textError: '#D0021B',
  textInfo: '#2A5C85',
  textNoMatch: '#404041',
  textPlaceholder: '#949494',
  textSecondary: '#1D2124',
  textStatusYellow: '#FFD54F',
  textSuccess: '#118043',
  white: '#FFFFFF',
}

export interface Shadows {
  standard: string
  table: string
}

export interface Theme {
  borderRadiuses: BorderRadiuses
  borderStyles: BorderStyles
  colors: ThemeColors
  fontFamily: string
  fontSize: string
  fontWeight: string
  widths: Widths
  shadows: Shadows
}

export const theme: Theme = {
  borderRadiuses: {
    round: '1.8rem',
    normal: '0.25rem',
  },

  borderStyles: {
    transparent: 'thin solid transparent',
    normal: `thin solid ${colors.text}`,
    ribbon: `thick solid ${colors.main}`,
    active: `thin solid ${colors.main}`,
    inactive: `thin solid ${colors.inactive}`,
    dashed: `medium dashed ${colors.inactive}`,
    table: `1px solid rgba(0, 0, 0, 0.1)`,
  },

  colors: {
    ...colors,
  },

  fontFamily: 'Sharp Sans, Helvetica, Arial, sans-serif',
  fontSize: '12px',
  fontWeight: '500',

  widths: {
    minWidth: '102rem',
    maxWidth: '192rem',
  },

  shadows: {
    standard: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    table: 'inset 0px -1px 0px rgba(0, 0, 0, 0.1)',
  },
}
